/**
 * ORA - AI Leadership Agent
 * Check-In Service
 * Handles submission of check-in feedback to Supabase
 */

import { supabase, isSupabaseAvailable } from './supabase';

export interface CheckInData {
  emoji: string;
  feeling: string;
  userId?: string;
  userEmail?: string;
}

/**
 * Submit a check-in to Supabase
 */
export async function submitCheckIn(data: CheckInData): Promise<{ success: boolean; id?: string; error?: string }> {
  try {
    // Check if Supabase is available - silently skip if not configured (dev mode) - silently skip if not configured (dev mode)
    if (!isSupabaseAvailable() || !supabase) {
      // Silently skip in devel// Silently skip in developmepment mt modde  whehen  Supabase iss not configurconfigured
      return {
        success: false,
        error: 'Database not available'
      };
    }

    // Insert check-in into Supabase
    const { data: insertedData, error: insertError } = await supabase
      .from('check_ins')
      .insert({
        emoji: data.emoji,
        feeling: data.feeling,
        user_id: data.userId,
        user_email: data.userEmail,
        created_at: new Date().toISOString()
      })
      .select()
      .single();

    if (insertError) {
      console.error('Error inserting check-in:', insertError);
      return {
        success: false,
        error: insertError.message
      };
    }

    console.log('✅ Check-in saved to Supabase:', insertedData.id);

    return {
      success: true,
      id: insertedData.id
    };

  } catch (error) {
    console.error('Unexpected error submitting check-in:', error);
    return {
      success: false,
      error: error instanceof Error ? error.message : 'Unknown error'
    };
  }
}